import { languageSelector } from "@omni/ui/components/LanguageSelector/languageSelector.styles";
import { cn } from "@omni/utils/styles";

import { getLabel } from "@/components/General/LanguageSelector/partials/label.component";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";
import { setLanguageCookie } from "@/services/cookie.service";
import { Config } from "@/utils/config.utils";
import { useAlgoliaQueryHook } from "@/utils/hooks/algolia/useAlgoliaQuery.hook";
import { useIsClientSide } from "@/utils/hooks/isClient.hook";
import { useSharedWishListId } from "@/utils/hooks/useSharedWishlistId.hook";

import { LanguageSelectorComponentProps } from "../../languageSelector.types";

const LanguageToggleSelector = ({
    variant,
    color = "white"
}: LanguageSelectorComponentProps) => {
    const { t } = useGranite();

    const clientSide = useIsClientSide();

    const algoliaQuery = useAlgoliaQueryHook();
    const sharedWishListId = useSharedWishListId();

    const language = Config.languages.find(
        (language) => language.locale !== Config.general.locale
    );

    const handleOnClick = () => {
        if (!language) return;

        setLanguageCookie(language["language-code"]);
    };

    if (!clientSide) return null;
    if (!language) return null;

    return (
        <div className={cn("tw:h-full tw:flex tw:flex-col tw:justify-center")}>
            <a
                className={languageSelector({ layout: "toggle", color })}
                href={`${language.url}${algoliaQuery}${sharedWishListId}`}
                onClick={handleOnClick}
            >
                {getLabel({
                    language: language,
                    variant: variant,
                    t: t
                })}
            </a>
        </div>
    );
};

export default LanguageToggleSelector;
